module.exports = __webpack_public_path__ + "static/media/wallfinishes_lcs_60y_n.03fd9289.csv";